export default __webpack_public_path__ + "media/images/features/yado/instagram-596c84b011737dcd9577218bca531988.png";